<template>
    <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
        <TheSidebar />
        <TheAside />
        <CWrapper>
            <TheHeader />
            <div class="c-body">
                <main class="c-main">
                    <CContainer fluid>
                        <transition name="fade">
                            <router-view></router-view>
                        </transition>
                    </CContainer>
                </main>
            </div>
        </CWrapper>
    </div>
</template>

<script>
import TheSidebar from './TheSidebar';
import TheHeader from './TheHeader';
import TheAside from './TheAside';

export default {
    name: 'TheContainer',
    data() {
        return {
            data: []
        };
    },
    components: {
        TheSidebar,
        TheHeader,
        TheAside
    }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.custom-fluid {
    padding-left: 0 !important;
}

.custom-main {
    padding-top: 0 !important;
}
</style>
